import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'cpb-content-wrapper',
  templateUrl: './content-wrapper.component.html',
})
export class CapturumBuilderContentWrapperComponent extends FieldWrapper {
}
